import { Bot, type LucideIcon, Minus, UserRound } from 'lucide-react';

import { cn } from '@/lib/shadcn/utils';

import type { JobAutomation, StageKey } from './jobAutomation';

interface Chip {
  label: string;
  icon: LucideIcon;
  /** Finlay in brand colour, you in grey, a skipped call outlined. */
  tone: 'finlay' | 'you' | 'none';
}

const outreachChips: Record<JobAutomation['outreach'], Chip> = {
  finlay: { label: 'Finlay', icon: Bot, tone: 'finlay' },
  me: { label: 'You', icon: UserRound, tone: 'you' },
};

const prescreenChips: Record<JobAutomation['prescreen'], Chip> = {
  ai: { label: 'AI call', icon: Bot, tone: 'finlay' },
  human: { label: 'You', icon: UserRound, tone: 'you' },
  skip: { label: 'No call', icon: Minus, tone: 'none' },
};

const toneClass: Record<Chip['tone'], string> = {
  finlay: 'bg-secondary-150 text-primary-700',
  you: 'bg-muted text-foreground',
  none: 'border bg-background text-neutral-500',
};

interface AutomationChipProps {
  stage: StageKey;
  values: JobAutomation;
}

/** Who handles one stage of these values. */
export function AutomationChip({ stage, values }: AutomationChipProps) {
  const {
    label,
    icon: Icon,
    tone,
  } = stage === 'outreach'
    ? outreachChips[values.outreach]
    : prescreenChips[values.prescreen];
  return (
    <span
      className={cn(
        'inline-flex h-6 w-fit items-center gap-1.5 rounded-md px-2 text-xs font-medium whitespace-nowrap',
        toneClass[tone],
      )}
    >
      <Icon aria-hidden className="size-3.5" />
      {label}
    </span>
  );
}
